import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { stepTemplateKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import {
  listStepTemplatesContract,
  type ListStepTemplatesResponse,
  type StepTemplate
} from '@bliks-io/contracts';

/** Tenant-wide Schrittvorlagen, newest first. Org Managers only (403 otherwise). */
export function useStepTemplates() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: stepTemplateKeys.list(),
    queryFn: async ({ signal }): Promise<StepTemplate[]> => {
      const { data } = await apiClient.get<ListStepTemplatesResponse>(
        listStepTemplatesContract.path,
        { signal }
      );
      return data.data;
    },
    enabled: !!token
  });
}
